var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.click}},[_c('span',{staticClass:"dia-mes"},[_vm._v(_vm._s(_vm.parseDate(_vm.row[_vm.column.field])))]),_c('span',{staticClass:"nome-dia"},[_vm._v(_vm._s(_vm.parseDateName(_vm.row[_vm.column.field])))])])
}
var staticRenderFns = []

export { render, staticRenderFns }